import React, { useState } from "react";
import {
    Drawer,
    DrawerBody,
    DrawerHeader,
    DrawerOverlay,
    DrawerContent,
    DrawerCloseButton,
    FormControl,
    FormLabel,
    Select,
    Input,
    Button,
    VStack,
    Text,
    Box,
} from "@chakra-ui/react";

const FilterDrawer = ({ isOpen, onClose, onFilter }) => {
    const [filters, setFilters] = useState({
        category: "All",
        league: "All",
        teamOne: "All",
        teamTwo: "All",
        gameStartedFrom: "",
        betStartedFrom: "",
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFilters((prev) => ({ ...prev, [name]: value }));
    };

    const handleApply = () => {
        onFilter(filters);
        onClose();
    };

    return (
        <Drawer isOpen={isOpen} placement="right" onClose={onClose} size={{ base: "full", md: "sm" }}>
            <DrawerOverlay />
            <DrawerContent>
                <DrawerCloseButton />
                <DrawerHeader borderBottomWidth="0px" fontSize="xl" fontWeight="600" pt={8} px={6}>
                    Filter by
                </DrawerHeader>

                <DrawerBody px={6}>
                    <VStack spacing={6} align="stretch" mt={4}>
                        <FormControl>
                            <FormLabel fontWeight="600" mb={2}>Category</FormLabel>
                            <Select
                                name="category"
                                value={filters.category}
                                onChange={handleChange}
                                h="50px"
                                borderColor="gray.200"
                                borderRadius="md"
                            >
                                <option value="All">All</option>
                                <option value="Mixed Martial Arts">Mixed Martial Arts</option>
                                <option value="Soccer">Soccer</option>
                                <option value="Cricket">Cricket</option>
                            </Select>
                        </FormControl>

                        <FormControl>
                            <FormLabel fontWeight="600" mb={2}>League</FormLabel>
                            <Select
                                name="league"
                                value={filters.league}
                                onChange={handleChange}
                                h="50px"
                                borderColor="gray.200"
                                borderRadius="md"
                            >
                                <option value="All">All</option>
                                <option value="MMA">MMA</option>
                                <option value="Ligue 2 – France">Ligue 2 – France</option>
                            </Select>
                        </FormControl>

                        <FormControl>
                            <FormLabel fontWeight="600" mb={2}>Team One</FormLabel>
                            <Select
                                name="teamOne"
                                value={filters.teamOne}
                                onChange={handleChange}
                                h="50px"
                                borderColor="gray.200"
                                borderRadius="md"
                            >
                                <option value="All">All</option>
                                <option value="Rose Namajunas">Rose Namajunas</option>
                                <option value="Wiktor Zalewski">Wiktor Zalewski</option>
                            </Select>
                        </FormControl>

                        <FormControl>
                            <FormLabel fontWeight="600" mb={2}>Team Two</FormLabel>
                            <Select
                                name="teamTwo"
                                value={filters.teamTwo}
                                onChange={handleChange}
                                h="50px"
                                borderColor="gray.200"
                                borderRadius="md"
                            >
                                <option value="All">All</option>
                                <option value="Natalia Silva">Natalia Silva</option>
                                <option value="Romain Debienne">Romain Debienne</option>
                            </Select>
                        </FormControl>

                        <FormControl>
                            <FormLabel fontWeight="600" mb={2}>Game Started From</FormLabel>
                            <Input
                                name="gameStartedFrom"
                                value={filters.gameStartedFrom}
                                onChange={handleChange}
                                placeholder="Start Date - End Date"
                                h="50px"
                                borderColor="gray.200"
                                borderRadius="md"
                                _placeholder={{ color: "gray.300" }}
                            />
                        </FormControl>

                        <FormControl>
                            <FormLabel fontWeight="600" mb={2}>Bet Started From</FormLabel>
                            <Input
                                name="betStartedFrom"
                                value={filters.betStartedFrom}
                                onChange={handleChange}
                                placeholder="Start Date - End Date"
                                h="50px"
                                borderColor="gray.200"
                                borderRadius="md"
                                _placeholder={{ color: "gray.300" }}
                            />
                        </FormControl>

                        <Button
                            bg="#4f46e5"
                            color="white"
                            h="55px"
                            w="100%"
                            _hover={{ bg: "#4338ca" }}
                            fontSize="md"
                            fontWeight="bold"
                            onClick={handleApply}
                            mt={4}
                        >
                            Filter
                        </Button>
                    </VStack>
                </DrawerBody>
            </DrawerContent>
        </Drawer>
    );
};

export default FilterDrawer;
